export default "__VITE_ASSET__46ef5ff1__"